export default "__VITE_ASSET__f87d65a7__"